var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounReturn7682942(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m831.14 197.29h-404.39c-19.922 0.046875-36.047 16.219-36.094 36.094v72.188c0.046876 19.922 16.172 36.047 36.094 36.094h404.39c91.078 0.79688 164.48 74.812 164.48 165.89 0 91.031-73.406 165.1-164.48 165.84h-517.55l61.781-61.781-0.046875 0.046875c28.078-28.266 28.078-73.875 0-102.09-28.219-28.078-73.828-28.078-102.05 0l-200.95 200.9c-18.281 18.375-18.281 48.047 0 66.375l204.79 204.74c28.219 28.078 73.828 28.078 102.05 0 28.078-28.266 28.078-73.875 0-102.09l-61.781-61.781h513.74c109.69-1.6406 210.37-61.125 264.74-156.42 54.371-95.293 54.375-212.21 0-307.5-54.375-95.293-155.06-154.78-264.74-156.47z",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounReturn7682942);
export default __webpack_public_path__ + "static/media/noun-return-7682942.83e04be2bb85d9fc8d0759aa45b7d0d0.svg";
export { ForwardRef as ReactComponent };